// Green "New" bubble, shown for 30 days after a feature ships, then hidden for everyone.
const SHIPPED = {
  "diagnosis-library": "2026-11-02", "medication-library": "2026-11-02", "prescriptions": "2026-11-02",
  "pharmacy-directory": "2026-11-02", "prescription-log": "2026-11-02", "prescriber-profile": "2026-11-02",
  "prescriber-dashboard": "2026-11-02", "rx-record-sheet": "2026-11-02", "med-favorites": "2026-11-02",
  "outside-meds": "2026-11-02", "no-current-meds": "2026-11-02",
  "refill-call-queue": "2026-11-03", "patient-education": "2026-11-03",
  "handout-reminders": "2026-11-03", "communication-log": "2026-11-03", "public-health": "2026-11-03",
};
const DAYS_SHOWN = 30;

export function isNew(feature) {
  const d = SHIPPED[feature];
  return !!d && Date.now() < new Date(`${d}T00:00:00Z`).getTime() + DAYS_SHOWN * 86400000;
}

export function NewPill({ feature, className = "" }) {
  if (!isNew(feature)) return null;
  return (
    <span data-testid={`new-pill-${feature}`} title={`New, added ${SHIPPED[feature]}`}
      className={`inline-flex shrink-0 items-center rounded-full bg-[#2E7D32] px-1.5 py-0.5 text-[9px] font-bold uppercase leading-none tracking-wide text-white shadow-[0_0_0_2px_rgba(46,125,50,0.15)] ${className}`}>
      New
    </span>
  );
}
